import { render, staticRenderFns } from "./Centralizator.vue?vue&type=template&id=2f04e437"
import script from "./Centralizator.vue?vue&type=script&lang=js"
export * from "./Centralizator.vue?vue&type=script&lang=js"
import style0 from "./Centralizator.vue?vue&type=style&index=0&id=2f04e437&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports